const environments = {
    development: {
        transform: (url, params, prefix = '/bilibili') => ({
            url: `${prefix}${url}`,
            params
        })
    },
    // 生产环境同样走同源代理：
    // - /bilibili -> api.bilibili.com
    // - /live -> api.live.bilibili.com
    production: {
        transform: (url, params, prefix = '/bilibili') => ({
            url: `${prefix}${url}`,
            params
        })
    }
}

const config = {
    getApiUrl: (url, params, prefix = '/bilibili') => {
        const env = process.env.NODE_ENV || 'development'
        return environments[env].transform(url, params, prefix)
    }
};

export default config;
